const getCurrentOrigin = () => window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
const EXTERNAL_REGISTER_TRACKING_KEY = 'externalRegisterTrackingQueryStr';

const getCookieValue = (cookieName, getCookie) => {
    if (typeof getCookie === 'function') {
        return getCookie(cookieName);
    }

    return window.SPL_Cookie?.getCookie?.(cookieName);
};

const hasCookieValue = (value) => value && value !== 'undefined' && value !== 'null';

const normalizeQueryString = (queryString) => {
    try {
        return decodeURIComponent(queryString);
    } catch {
        return queryString;
    }
};

const buildRequestUrlWithQueryString = (origin, queryString) => {
    if (window.location.search) {
        return `${origin}${window.location.pathname}?${queryString}`;
    }

    try {
        const referrer = new URL(document.referrer);

        if (referrer.origin === origin && referrer.search) {
            return `${referrer.origin}${referrer.pathname}?${queryString}`;
        }
    } catch {
        // Ignore invalid or empty referrer and use the standard register path.
    }

    return `${origin}/register?${queryString}`;
};

const buildRegisterRequestUrlWithQueryString = (origin, queryString) => `${origin}/register?${queryString}`;

const getSessionTrackingQueryString = () => {
    try {
        return window.sessionStorage?.getItem(EXTERNAL_REGISTER_TRACKING_KEY);
    } catch {
        return null;
    }
};

const persistExternalRegisterTrackingQueryString = (queryString) => {
    try {
        window.sessionStorage?.setItem(EXTERNAL_REGISTER_TRACKING_KEY, queryString);
    } catch {
        // Ignore blocked session storage and keep the cookie fallback below.
    }

    window.SPL_Cookie?.setCookie?.(EXTERNAL_REGISTER_TRACKING_KEY, queryString, 1);
};

const clearExternalRegisterTrackingQueryString = () => {
    try {
        window.sessionStorage?.removeItem(EXTERNAL_REGISTER_TRACKING_KEY);
    } catch {
        // Ignore blocked session storage and clear the cookie fallback below.
    }

    window.SPL_Cookie?.deleteCookie?.(EXTERNAL_REGISTER_TRACKING_KEY);
};

const isSocialCallbackQueryString = (queryString) => {
    const urlParams = new URLSearchParams(queryString);

    return urlParams.has('socialMediaUserId') || urlParams.has('socialMediaProvider') || urlParams.has('requestToken');
};

const getStoredExternalRegisterQueryString = (getCookie) => {
    const candidates = [
        getSessionTrackingQueryString(),
        getCookieValue(EXTERNAL_REGISTER_TRACKING_KEY, getCookie),
        getCookieValue('affNetworkQueryStr', getCookie),
        getCookieValue('queryStr', getCookie),
    ];

    return candidates.map(normalizeQueryString).find((queryString) => hasCookieValue(queryString) && !isSocialCallbackQueryString(queryString));
};

export const getExternalRegisterTrackingParams = (action, getCookie) => {
    const origin = getCurrentOrigin();

    if (action !== 'register') {
        return { requestUrl: origin };
    }

    const queryString = normalizeQueryString(getCookieValue('queryStr', getCookie));

    if (!hasCookieValue(queryString)) {
        clearExternalRegisterTrackingQueryString();

        return { requestUrl: origin };
    }

    persistExternalRegisterTrackingQueryString(queryString);

    return {
        requestUrl: buildRequestUrlWithQueryString(origin, queryString),
        queryString,
    };
};

export const getExternalQuickRegisterTrackingParams = (getCookie) => {
    const queryString = getStoredExternalRegisterQueryString(getCookie);

    if (!hasCookieValue(queryString)) {
        return {};
    }

    const origin = getCurrentOrigin();

    return {
        requestUrl: buildRegisterRequestUrlWithQueryString(origin, queryString),
        queryString,
    };
};
